import React, {useEffect, useState } from 'react';
import Card from 'Components/DesignSystem/Card/Card';
import TextField from 'Components/DesignSystem/TextField/TextField';
import {FIELD_DETAILS, TITLE, TRANSFORMATION_NAME } from '../ISRConstants';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput, TTransformation } from '../Pages/DefineModel/model';

type TTransformationComponentProps = {
    id: string;
    subSelectedItem: TTransformation|null;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null ;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    indexInfo: TIndexState;
    createISRProject:()=>void
}

const TransformationComponent = ({id, subSelectedItem, selectedItem, setUserProjectDataModels, userProjectDataModels, indexInfo, createISRProject}: TTransformationComponentProps) => {
    const [fieldName, setFieldName] = useState<string>('');

    useEffect(() => {
        const productCategory = selectedItem as TProductCategory;
        if (productCategory?.data?.belongsToDataModel) {
            setFieldName(userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.data?.productCategories[indexInfo?.categoryIndex ?? -1]?.data?.transformations[indexInfo?.TransformationIndex ?? -1]?.name ?? "");
        } else {
            setFieldName(userProjectDataModels?.project.productCategories[indexInfo?.categoryOutsideDataModelIndex ?? -1]?.data?.transformations[indexInfo?.TransformationIndex ?? -1]?.name ?? "");
        }
    }, [selectedItem, subSelectedItem]);

    const handleTransformationNameChange = (value: string) => {
        setFieldName(value);
        updateFieldName(value);
    };

    const updateFieldName = (fieldName: string) => {
        const productCategory = selectedItem as TProductCategory;
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            if (productCategory && productCategory?.data?.belongsToDataModel) {
                const dataModelToUpdate = newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
                if (dataModelToUpdate && dataModelToUpdate.data && dataModelToUpdate.data.productCategories[indexInfo?.categoryIndex ?? -1]) {
                    dataModelToUpdate.data.productCategories[indexInfo.categoryIndex ?? -1].data.transformations[indexInfo.TransformationIndex??-1].name = fieldName;

                }
                newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1] = dataModelToUpdate
            } else {
                const fieldToUpdate = newDataModels.project.productCategories[indexInfo?.fieldOutsideDataModelIndex ?? -1];
                if (fieldToUpdate && fieldToUpdate.data && fieldToUpdate.data?.transformations[indexInfo.TransformationIndex??-1] ) {
                    fieldToUpdate.data.transformations[indexInfo.TransformationIndex??-1].name = fieldName;
                }
                newDataModels.project.productCategories[indexInfo?.fieldOutsideDataModelIndex ?? -1] = fieldToUpdate
            }
        return newDataModels;});
        createISRProject()
    };

    return (
        <Card id={id} data-testid={id} title={FIELD_DETAILS}>
            <div id={`${id}-content`} className='tw-flex tw-items-start'>
                <TextField
                    id={`${id}-input`}
                    data-testid="components-transformationcomponent-input-1"
                    label={TITLE}
                    required
                    value={fieldName}
                    onChange={handleTransformationNameChange}
                    placeholder={TRANSFORMATION_NAME}
                    className='tw-w-[60%]'
                />
            </div>
        </Card>
    );
}

export default TransformationComponent;